export function withChartSettings(chartSettings, defaultType) {
  return {
    ...chartSettings,
    type: chartSettings?.type || defaultType,
  };
}
